import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="video-modal"
export default class extends Controller {
  static targets = ["video", "modal"]
  static values = { modalId: String }

  connect() {
    // 监听 ESC 键
    this.boundHandleEscape = this.handleEscape.bind(this)
    document.addEventListener('keydown', this.boundHandleEscape)

    // 监听模态框的 class 变化
    this.setupModalObserver()

    // 监听点击模态框外部区域
    this.boundHandleOutsideClick = this.handleOutsideClick.bind(this)
    this.element.addEventListener('click', this.boundHandleOutsideClick)

    // 监听 Flowbite 模态框事件
    this.setupFlowbiteEvents()
  }

    disconnect() {
    // 清理事件监听器
    if (this.boundHandleEscape) {
      document.removeEventListener('keydown', this.boundHandleEscape)
    }

    if (this.boundHandleOutsideClick) {
      this.element.removeEventListener('click', this.boundHandleOutsideClick)
    }

    // 清理 MutationObserver
    if (this.modalObserver) {
      this.modalObserver.disconnect()
    }
  }

  // 设置模态框状态监听器
  setupModalObserver() {
    // 监听整个模态框元素（this.element）的 class 变化
    this.modalObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const target = mutation.target
          // 当模态框被隐藏时暂停视频
          if (target.classList.contains('hidden')) {
            this.pauseVideo()
          }
        }
      })
    })

    // 监听模态框元素的 class 变化
    this.modalObserver.observe(this.element, {
      attributes: true,
      attributeFilter: ['class']
    })
  }

  // 关闭模态框时调用
  closeModal() {
    this.pauseVideo()
  }

  // 暂停视频并重置到开始位置
  pauseVideo() {
    if (this.hasVideoTarget) {
      this.videoTarget.pause()
      this.videoTarget.currentTime = 0
    }
  }

  // 处理 ESC 键
  handleEscape(event) {
    if (event.key === 'Escape') {
      this.pauseVideo()
    }
  }

  // 设置 Flowbite 模态框事件监听
  setupFlowbiteEvents() {
    // 监听 Flowbite 的隐藏事件
    this.element.addEventListener('hide.bs.modal', () => {
      this.pauseVideo()
    })

    this.element.addEventListener('hidden.bs.modal', () => {
      this.pauseVideo()
    })

    // 监听 Flowbite 的自定义隐藏事件
    this.element.addEventListener('hide', () => {
      this.pauseVideo()
    })
  }

  // 处理点击模态框外部区域
  handleOutsideClick(event) {
    // 如果点击的是模态框背景（而不是内容区域），则关闭模态框
    if (event.target === this.element) {
      this.pauseVideo()
    }
  }

  // 打开模态框时可以调用的方法（可选）
  openModal() {
    // 可以在这里添加打开模态框时的逻辑
    // 比如重置视频到开始位置
    if (this.hasVideoTarget) {
      this.videoTarget.currentTime = 0
    }
  }
}
